import moment from "moment-timezone";
moment.tz.setDefault("Etc/UTC");
export default moment;
